<script setup lang="ts">
import CheckpointSummary from "~/dto/checkpoint/Summary";

defineProps({
  summary: {
    type: CheckpointSummary,
    required: true
  }
});
</script>

<template>
  <div
      class="card h-100"
      role="button"
      @click="navigateTo({ name: 'checkpoint-code', params: { code: summary.code } })"
  >
    <div class="card-body bg-body-secondary text-center px-1">
      <h5 class="card-title">
        {{ summary.name }}
      </h5>
      <div>
        <div
            v-if="summary.carsQueues"
            class="d-inline-block me-1"
        >
          <i class="cil-car icon icon-lg" />
          <span class="h5 ms-1">{{ summary.carsQueues.total }}</span>
        </div>
      </div>
      <div>
        <div
            v-if="summary.carsQueues?.live.duration"
            class="d-inline-block"
        >
          <i class="cil-hourglass icon icon-lg" />
          <FormattedQueueDuration
              class="ms-1"
              :duration="summary.carsQueues.live.duration"
          />
        </div>
      </div>
    </div>
  </div>
</template>

